import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useSiteContext } from '../context/site-context';
import { usePostContext } from './context';
import { LoadingScreen } from '../../loading-screen';

export default function PostView({ children }) {
  const {site} = useSiteContext();

  const {postTypeConfig, postTypeIsLoading} = usePostContext()

  if (postTypeIsLoading) {
    return (
      <Box
        sx={{
          width: 1,
          flexGrow: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
        }}
      >
        <LoadingScreen />
      </Box>
    );
  }

  if (!site) {
    return <div>サイトを選択してください。</div>;
  }

  if (!postTypeConfig) {
    return <div>POST TYPEを選択してください。</div>
  }

  return children
}

PostView.propTypes = {
  children: PropTypes.node,
};
